import * as React from 'react';

export type VideoProps = {
	code: string;
	ratio?: string;
};

const Video = ({ code, ratio }: VideoProps) => {
	const opts: { [key: string]: any } = {};

	if (typeof ratio === 'string') {
		opts.style = {
			paddingBottom: ratio,
		};
	}

	return (
		<div
			{...opts}
			className="a-video"
			dangerouslySetInnerHTML={{
				__html: code,
			}}
		/>
	);
};

export default Video;
